export const CONFIRM_UPDATE = 'CONFIRM_UPDATE'
export const BANK_SLIP_MODAL = 'BANK_SLIP_MODAL'
export const TOKEN_MODAL = 'TOKEN_MODAL'
export const INPUT_MODAL = 'INPUT_MODAL'
export const PAYMENT_CONFIRMATION_MODAL = 'PAYMENT_CONFIRMATION_MODAL'
export const QRCODE_MODAL = 'QRCODE_MODAL'
